// initial state
export const state = {
  token: localStorage.getItem('token'),
  email: localStorage.getItem('email'),
  superuser: localStorage.getItem('superuser') == 'true',
  staff: localStorage.getItem('staff') == 'true',
  groups: localStorage.getItem('groups') ? JSON.parse(localStorage.getItem('groups')) : null,
}
 
// mutations
export const mutations = {
  setUser (state, user) {
    state.token = user.token
    state.email = user.email
    state.superuser = user.superuser
    state.staff = user.staff
    state.groups = user.groups
  },


  reset (state) {
    state.token = null
    state.email = null
    state.superuser = false
    state.staff = false
    state.groups = null
    localStorage.removeItem('token')
    localStorage.removeItem('email')
    localStorage.removeItem('superuser')
    localStorage.removeItem('staff')
    localStorage.removeItem('groups')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
